import { render, staticRenderFns } from "./StatsDashboard.vue?vue&type=template&id=338b1103&"
import script from "./StatsDashboard.vue?vue&type=script&lang=js&"
export * from "./StatsDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports